
import { Package } from "lucide-react";

interface AppIconProps {
  app_icon_url?: string;
  app_name: string;
  size?: "sm" | "md" | "lg";
}

export const AppIcon = ({ app_icon_url, app_name, size = "md" }: AppIconProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-6 h-6"
  };

  return (
    <div className={`${sizeClasses[size]} bg-blue-100 rounded flex items-center justify-center`}>
      {app_icon_url ? (
        <img 
          src={app_icon_url} 
          alt={app_name}
          className={`${sizeClasses[size]} rounded`}
        />
      ) : (
        <Package className={`${iconSizes[size]} text-blue-600`} />
      )}
    </div>
  );
};
